import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BasicPersonData} from '../../types/person/basic-person-data';
import {PersonRestService} from '../../services/person/person-rest.service';

@Component({
  selector: 'wsd-select-person-ac',
  templateUrl: './select-person-ac.component.html',
  styleUrls: ['./select-person-ac.component.css']
})
export class SelectPersonAcComponent {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label = 'SELECT_PERSON_AC.LABEL';

  @Input()
  placeholder = 'SELECT_PERSON_AC.PLACEHOLDER';

  @Input()
  controlName = 'person';

  @Input()
  fromAll: Boolean = false;

  @Input()
  showLabel = true;

  @Input()
  showPlaceholder = true;

  @Input()
  count = 10;

  @Output()
  onSelect: EventEmitter<BasicPersonData> = new EventEmitter();

  persons: BasicPersonData[] = [];

  constructor(private personRestService: PersonRestService) {
  }

  filterPersons(event) {
    if (!this.fromAll) {
      this.personRestService.findBy(event.query, {page: 0, size: this.count}).subscribe(
        (data: BasicPersonData[]) => this.persons = data
      );
      return;
    }
    this.personRestService.findFromAllBy(event.query, {page: 0, size: this.count}).subscribe(
      (data: BasicPersonData[]) => this.persons = data
    );
  }

  onSelectValue(event) {
    this.onSelect.emit(event);
  }

}
